import { QueryPayload } from 'generated-service-lib';
import * as generatedServices from '../generatedServices';

export class CalculationLogService {
  readonly unvalidatedClient: generatedServices.GeneratedCalculationLogService = new generatedServices.GeneratedCalculationLogService();
  constructor(domain?: string) {
    this.unvalidatedClient = new generatedServices.GeneratedCalculationLogService(domain);
  }

  getCalculationLogs = async (clientId: string, query: QueryPayload) => {
    return await this.unvalidatedClient.postLogClientsByClientIdCalculations({
      clientId: clientId,
      body: query,
    });
  };
}
